import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {Paper} from '@material-ui/core'
import css from './HowItWorkPage.module.css';
import CustomerIcon from '../../assets/icons/customer'
import ProviderIcon from '../../assets/icons/provider'

const SectionHeader = (props) => {
  // prettier-ignore
  return (<div>
        <div className={css.headerWrapper}>
            <h1 className={css.title}><FormattedMessage id="HowItWorkPage.title" /></h1>
       </div>
       <div className={css.wrapperButton}>
                <Paper className={props.current === "provider" ? css.boxButtonActive : css.boxButton}  elevation={3} onClick={() => props.onChange('provider')}>
                    <div style={{textAlign: "center"}}>
                    <p className={css.buttonTitle}>
                    <ProviderIcon />
                        <FormattedMessage id="HowItWorkPage.provider" />
                    </p>
                    </div>
                </Paper>
                <Paper  className={props.current === "customer" ? css.boxButtonActive : css.boxButton}  elevation={3} onClick={() => props.onChange('customer')}>
                    <div style={{textAlign: "center"}}>
                    <p className={css.buttonTitle}>
                        <CustomerIcon />
                        <FormattedMessage id="HowItWorkPage.customer" />
                    </p>
                    </div>
                </Paper>
            </div>
   </div>
  )
}

export default SectionHeader;